var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4425",
    "data-name": "Group 4425",
    transform: "translate(-947 -71)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_277",
    "data-name": "Ellipse 277",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(947 71)",
    fill: "#f87c7c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4421",
    "data-name": "Group 4421",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close",
    transform: "translate(947 71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4262",
    "data-name": "Path 4262",
    d: "M0,0H20V20H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4263",
    "data-name": "Path 4263",
    d: "M16,6,6,16",
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4264",
    "data-name": "Path 4264",
    d: "M6,6,16,16",
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4fcea5031ee9b822417a19445ede7cbb.svg";
export { ForwardRef as ReactComponent };